import React from 'react'
import { PeopleIcon } from '@primer/octicons-react'

const Porcentaje = ({ total, porcion, simple }) => {
  const amount = ((porcion / total) * 100).toFixed(2)
  return (
    <h4 className="porcentaje">
      {simple ? (
        <span>
          {amount}%{' '}
          <small className="block text-sm">
            (<PeopleIcon size={16} /> {porcion})
          </small>
        </span>
      ) : (
        <span>
          {amount}%{' '}
          <small className="block text-sm">
            (<PeopleIcon size={16} /> {porcion})
          </small>
        </span>
      )}
    </h4>
  )
}

export default Porcentaje
